import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconHouseboat = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconHouseboat",
  ref: ref,
  ...props,
  children: _jsx("path", {
    d: "M480-240q-38 0-56 20t-77 20q-57 0-77-20t-56-20q-28 0-45 14t-49 21q-16 4-28-7t-12-28 12-29 27-21l36-19q19-10 58-11 58 0 78 20t55 20q38 0 57-20t77-20 78 20 56 20q35 0 55-20t78-20q39 0 58 11t36 19q15 8 27 21t12 29-12 28-28 7q-32-8-49-21t-45-14q-36 0-56 20t-77 20q-59 0-77-20t-56-20M230-360q-24 0-46-9t-39-26l-27-27q-11-11-11-27t11-29q11-11 28-11t28 10l27 27q6 6 14 9t15 3h50v-135l-21 16q-14 10-29 8t-26-17-8-29 16-26l221-162q11-8 23-12t24-4 25 4 22 12l221 162q14 10 17 26t-8 29-26 17-31-8l-20-15v134h50q8 0 16-3t13-9l27-27q11-11 28-11t28 12q11 11 11 28t-11 28l-27 27q-17 17-39 26t-46 9zm290-80v-40q0-17-11-28t-29-12-28 12-12 28v40z"
  })
}));
IconHouseboat.displayName = 'IconHouseboat';